import React from "react";
import * as styles from "./SectionDivider.module.scss";

export const SectionDivider = () => {
  return <div className={styles.divider} />;
};
